import countries from 'i18n-iso-countries';
import deLocale from 'i18n-iso-countries/langs/de.json';
import enLocale from 'i18n-iso-countries/langs/en.json';
import esLocale from 'i18n-iso-countries/langs/es.json';
import frLocale from 'i18n-iso-countries/langs/fr.json';
countries.registerLocale(frLocale);
countries.registerLocale(enLocale);
countries.registerLocale(esLocale);
countries.registerLocale(deLocale);
const supportedLocales = ['fr', 'en', 'es', 'de'];
export function getCountries(locale) {
  const lang = supportedLocales.includes(locale) ? locale : 'en';
  const names = countries.getNames(lang);
  return Object.entries(names).map(([code, name]) => ({
    code: code.toLowerCase(),
    name
  })).sort((a, b) => a.name.localeCompare(b.name, lang));
}